export const CommentPlusIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 0V19H20" stroke="#DACAFF" />
    </svg>
  );
};

export const ReplyIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: "0.5rem" }}
    >
      <path d="M1 0V19H20" stroke="#DACAFF" />
    </svg>
  );
};
